import { useEffect, useMemo, useState } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import axios from 'axios';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveIcon from '@mui/icons-material/Remove';
import PauseIcon from '@mui/icons-material/Pause';
import InfoIcon from '@mui/icons-material/Info';
//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

//Material UI Imports
import {
  Box,
  Chip,
  Tooltip,
  Typography,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useOrganizationSelect } from '../../../context/OrganizationSelectContext';
import { useSelector } from 'react-redux';

   


const EsetLicenses = () => {

   const [filteredEsetLicenses, setfilteredEsetLicenses] = useState([]);
  
    const { data: esetLicenses = [], loading, error } = useSelector((state) => state.eset.licenses);
  

    const { selectedOrganization } = useOrganizationSelect();

    useEffect(() => {
      if (selectedOrganization) {
        setfilteredEsetLicenses(esetLicenses.filter(
          (item) => item.organizationName === selectedOrganization
        ));
      } else {
        setfilteredEsetLicenses(esetLicenses);
      }
    }, [selectedOrganization, esetLicenses]);
  

    const columns = useMemo(
      () => [
        {
          id: 'licenses', //id used to define `group` column
          columns: [
            {
              accessorFn: (row) => row.licenseKey, //accessorFn used to join multiple data into a single cell
              id: 'LicenseID', //id is still required when using accessorFn instead of accessorKey
              header: 'ID Licence',
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >{renderedCellValue}
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
            {
              accessorKey: 'name', //hey a simple column for once
                header: 'Nom',
                filterVariant: 'autocomplete',
            },
                {
                accessorKey: 'used', //hey a simple column for once
                header: 'Utilisé',
                size: 50,
                Cell: ({ cell }) => {
                  const isOverused = cell.row.original.used > cell.row.original.quantity;
                  return (
                  <Box
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    color: isOverused ? 'red' : 'inherit',
                    }}
                  >
                    {cell.getValue()}
                    {isOverused && (
                    <Tooltip title="Utilisation dépasse la quantité disponible">
                      <ErrorOutlineIcon fontSize="small" color="error" />
                    </Tooltip>
                    )}
                  </Box>
                  );
                },
                },
                {
                accessorKey: 'quantity', //hey a simple column for once
                header: 'Total',
                size: 50,
              },
              {
                accessorFn: (row) => row.trial ? "Trial" : "Full", // Directly use the array
                id: 'trial', // id is required
                header: 'Type',
                size: 100,
                Cell: ({ row }) => (
                  <Box
                  sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  }}
                  >
                  {row.original.trial ? (
                  <Tooltip title={row.original.trialExpiration ? `Expiration: ${new Date(row.original.trialExpiration).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'UTC' })}` : "No expiration date"} >
                    <Chip label={"Trial"} icon={<CheckCircleIcon color='warning' />} size="small" variant="outlined" />

                  </Tooltip>
                  ) : (
                    <Chip label={"Full"} icon={<CheckCircleIcon color='success' />} size="small" variant="outlined" />
                  )}
                  </Box>
                ),
                filterVariant: 'autocomplete',
                },
                
              {
                accessorFn: (row) => row.organizationDetails?.name, //accessorFn used to join multiple data into a single cell
              id: 'organization', //id is still required when using accessorFn instead of accessorKey
              header: 'Client',
              size: 250,
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >{renderedCellValue}
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
             {
                    accessorFn: (row) => row.status === 3 ? "Suspended" : row.status === 1 || 4 ? "Normal" : row.status === 0 ? "Error" : "Inconnu",
                    id: 'status',
                    header: 'Status',
                    size: 40,
                    Cell: ({ renderedCellValue, row }) => (
                    <Box
                      sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      }}
                    >
                      {renderedCellValue === "Suspended" ? (
                        <Chip label={"Suspendu"} icon={<PauseIcon color='warning' />} size="small" variant="outlined" />
                      ) : renderedCellValue === "Normal" ? (
                        <Chip label={"Normal"} icon={<CheckCircleIcon color='success' />} size="small" variant="outlined" />
                      ) : renderedCellValue === "Error" ? (
                        <Chip label={"Error"} icon={<CheckCircleIcon color='error' />} size="small" variant="outlined" />
                      ) : (
                        <Chip label={renderedCellValue} size="medium" variant="outlined" />
                      )}
                    </Box>
                    ),
                    filterVariant: 'autocomplete',
                    }, 
            
          ]}
      ],
      [],
    );
    
  
    const table = useMaterialReactTable({
      columns,
      data: filteredEsetLicenses ? filteredEsetLicenses : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
      enableColumnFilterModes: true,
      enableColumnOrdering: true,
      enableGrouping: true,
      enableColumnPinning: true,
      enableFacetedValues: true,
      initialState: {
      density: "compact",
      // showColumnFilters: true,
      // showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
      pagination: {
        pageSize: 50,
      }
      },
      paginationDisplayMode: 'pages',
      positionToolbarAlertBanner: 'bottom',
      muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
      },
      muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [50, 100, 150],
      shape: 'rounded',
      variant: 'outlined',
      },
      renderDetailPanel: ({ row }) => (
      <Box
        sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-around',
        left: '30px',
        maxWidth: '1000px',
        position: 'sticky',
        width: '100%',
        }}
      >
        <Box sx={{ textAlign: 'center', width: '100%' }}>
        <DataGrid
          rows={row.original.relatedDevices.map((device, index) => ({
          id: index,
          name: device.name,
          last_sync: new Date(device.lastSync).toLocaleString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'UTC',
          }),
          }))}
          disableColumnResize
          density="compact"
          getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          columns={[
          { field: 'name', headerName: 'Nom', flex: 1 },
          { field: 'last_sync', headerName: 'Dernière synchronisation', flex: 1 },
          ]}
          pageSize={5}
          rowsPerPageOptions={[5]}
          slotProps={{
          filterPanel: {
            filterFormProps: {
            logicOperatorInputProps: {
              variant: 'outlined',
              size: 'small',
            },
            columnInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            operatorInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            valueInputProps: {
              InputComponentProps: {
              variant: 'outlined',
              size: 'small',
              },
            },
            },
          },
          }}
        />
        </Box>
      </Box>
      )
    });
  
  
    return (
      <Box>
        <Box>
          <Typography variant="h4" my={2}>Licences ESET</Typography>
        </Box>
        <Box>
          <MaterialReactTable table={table} />
        </Box>

      </Box>
      )};

export default EsetLicenses;
